import {chain} from 'lodash'
import React from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import {Consumer} from '../../context'
import './grade-filter.styl'

function GradeFilterButton({id, name, selected}) {
  const query = {grade: selected ? undefined : id}
  return (<Consumer key={id}>{ context => {
    return (
      <Link
        className={`grade filter ${selected ? 'selected' : ''}`}
        to={context.link({},context.match.params,{query, preserveQuery: true})}
      >
        {name}
      </Link>
    )
  }}</Consumer>)
}

export default function GradeFilter () {
  return (
    <Consumer>{ (context) => {

      const courseGrades = chain(context.catalogueCourses)
        .map(({grade}) => grade)
        .uniq()
        .value()

      const selectedGrade = context.query.grade || context.grade
      const grades = chain(context.grades)
        .intersectionWith(courseGrades, (a,b) => a.id == b)
        .orderBy(['precedence'])
        .map(g => ({...g, selected: g.id == selectedGrade}))
        .map(GradeFilterButton)
        .value() 

      return (
        <div className="grade-filters">
          <div className="label"><Text id="grades_label" />:</div>
          <div className="content">
            {grades}
          </div>
        </div>
      )}}
    </Consumer>)
}
